import * as foundation from "./foundation"
import { createBackgroundColors } from "../groupon/contextual/background"
import {
  createBorderWidths,
  createBorderColors,
  createBorderRadii,
} from "../groupon/contextual/border"
import {
  createFonts,
  createFontSizes,
  createLineHeights,
  createFontWeights,
  createTextColors,
} from "../groupon/contextual/typography"
import { createIconSizes, createIconColors } from "../groupon/contextual/icons"

export const backgroundColors = createBackgroundColors(foundation)
export const borderWidths = createBorderWidths(foundation)
export const borderColors = createBorderColors(foundation)
export const borderRadii = createBorderRadii(foundation)
export const fonts = createFonts(foundation)
export const fontSizes = createFontSizes(foundation)
export const lineHeights = createLineHeights(foundation)
export const fontWeights = createFontWeights(foundation)
export const textColors = createTextColors(foundation)
export const iconSizes = createIconSizes(foundation)
export const iconColors = createIconColors(foundation)
